var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['app-btn', { 'my-3 mt-4': !_vm.noMargin }, { disabled: _vm.disabled }],on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }